export const RT_URL = new URL('https://www.rottentomatoes.com');

export const RT_SEARCH_URL = new URL('/napi/search', RT_URL);
